<ng-container *adaptLoading="loading">
    <dx-scroll-view>
        <div class="d-flex flex-column gap-3 pb-3">
            @if (teamAgendaTemplates.length > 0) {
                <div>
                    <h3>{{teamAgendaTemplates[0].meetingTemplate.team?.name ?? "Unknown"}} Team templates</h3>
                    <div class="d-flex flex-row flex-wrap gap-2">
                        @for (agenda of teamAgendaTemplates; track agenda.meetingTemplate.meetingAgendaTemplateId) {
                            <ng-container *ngTemplateOutlet="agendaButton; context: { agenda }"></ng-container>
                        }
                    </div>
                </div>
            }

            @if (globalTemplates.length > 0) {
                <div>
                    <h3>Organisation templates</h3>
                    <div class="d-flex flex-row flex-wrap gap-2">
                        @for (agenda of globalTemplates; track agenda.meetingTemplate.meetingAgendaTemplateId) {
                            <ng-container *ngTemplateOutlet="agendaButton; context: { agenda }"></ng-container>
                        }
                    </div>
                </div>
            }

            @if (otherTeamAgendaTemplates.size > 0) {
                <div>
                    <h3>Meeting templates from other teams
                        <button [(adaptCollapsibleButton)]="otherTeamsCollapsed"></button>
                    </h3>
                    <div [collapse]="otherTeamsCollapsed"
                         [isAnimated]="false"
                         class="alert alert-light p-2 mb-0">
                        <div class="d-flex flex-column gap-2">
                            @for (item of otherTeamAgendaTemplates | keyvalue; track item.key.teamId) {
                                <div>
                                    <h3>{{item.key.name}} team</h3>
                                    <div class="d-flex flex-row flex-wrap gap-2">
                                        @for (agenda of item.value; track agenda.meetingTemplate.meetingAgendaTemplateId) {
                                            <ng-container *ngTemplateOutlet="agendaButton; context: { agenda }"></ng-container>
                                        }
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            }

            @if (pathwayTemplates.length > 0) {
                <div>
                    <h3>Pathway meeting templates
                        <button [(adaptCollapsibleButton)]="pathwaysCollapsed"></button>
                    </h3>
                    <div [collapse]="pathwaysCollapsed"
                         [isAnimated]="false"
                         class="alert alert-light p-2 mb-0">
                        <div class="d-flex flex-row flex-wrap gap-2">
                            @for (agenda of pathwayTemplates; track agenda.meetingTemplate.meetingAgendaTemplateId) {
                                <ng-container *ngTemplateOutlet="agendaButton; context: { agenda }"></ng-container>
                            }
                        </div>
                    </div>
                </div>
            }
        </div>
    </dx-scroll-view>
</ng-container>

<ng-template #agendaButton
             let-agenda="agenda">
    <adapt-display-agenda-name [agendaDetail]="agenda"
                               [isSelected]="selectedAgendaTemplate === agenda"
                               (agendaClicked)="onAgendaSelected($event)"></adapt-display-agenda-name>
</ng-template>
